<template>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'attachTenantName'"
                @click="toTenantDetail(scope.row)"
              >
                <span class="primary cur">
                  {{
                  scope.row[scope.column.property]
                  }}
                </span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  //  {
                  //   permpisions: '1002020201',
                  //   showCondition: scope.row.stateName === '处理中',
                  //   // showCondition:true,
                  //   name: '审核',
                  //   event: () => toApprove(scope.row,'approve'),
                  // },
                  {
                    showCondition: scope.row.isAuth === 1 && scope.row.state!==1,
                    name: '审核',
                    event: () => toApprove(scope.row,'approve'),
                  },
                  // {
                  //   permpisions: '1400106',
                  //   showCondition:
                  //     scope.row.applyCarUserType !== 1 &&
                  //     scope.row.state === 2 &&
                  //     !scope.row.newApplyId,
                  //   name: '再次邀请',
                  //   event: () => toEdit(scope.row.id, 1),
                  // },
                  //此处有bug需要处理，先暂时隐藏，可操作重新新增步骤
                  // {
                  //   permpisions: '',
                  //   showCondition:
                  //     scope.row.applyCarUserType === 1 &&
                  //     scope.row.state === 2 &&
                  //     !scope.row.newApplyId,
                  //   name: '再次申请',
                  //   event: () => toEdit(scope.row.id, 2),
                  // },
                  {
                    permpisions: '1400107',
                    showCondition:
                      scope.row.applyCarUserType === 1 &&
                      scope.row.state === 2 &&
                      !scope.row.newApplyId &&
                      scope.row.beApplyTenantId !== -1,
                    name: '申请平台仲裁',
                    event: () => toEdit(scope.row.id, 3),
                  },
                ]"
              />

            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  driverArchivesInviteList,
} from 'api/archives';
import {batchVerificationEtc} from 'api/service';
import {approve} from 'api/index';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'mobilePhone',
            label: '司机账号',
          },
          {
            prop: 'linkman',
            label: '司机名称',
          },
          {
            prop: 'applyCarUserTypeName',
            label: '申请类型',
          },
          {
            prop: 'attachTenantName',
            label: '车队名称',
          },
          {
            prop: 'attachTennantLinkPhone',
            label: '车队手机',
          },
          {
            prop: 'createDate',
            label: '申请时间',
          },
          {
            prop: 'stateName',
            label: '审核状态',
          },
          {
            prop: 'auditDate',
            label: '处理时间',
          },
          {
            prop: 'auditRemark',
            label: '处理意见',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverArchivesInviteList,
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.beApplyTenantId}`,
        full: true,
      });
    },
    toEdit (id, type) {
      let label = '';
      if (type === 1) {
        label = '再次邀请';
      } else if (type === 2) {
        label = '再次申请';
      } else {
        label = '申请平台仲裁';
      }
      this.jump({
        label,
        url: `/manage/archives/driver/invite/edit?id=${id}&type=${type}`,
        full: true,
      });
    },
    toApprove (item, type = '') {
      this.jump({
        label: type ? '审核被邀请' : '被邀请详情',
        url: `/manage/archives/driver/invited/detail?id=${item.id}&type=${type}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
